import { Info } from "@mui/icons-material"
import PropTypes from "prop-types"
import Tooltip from "components/material/tooltip"
import classNames from "classnames"

// Rendered as an Autocomplete renderOption element (an <li>). MUI v9's MenuItem
// now requires MenuListContext, so it can no longer be used outside a Menu/MenuList.
export function FilterOption({
  option: {
    label: optionLabel,
    tooltip = "",
  },
  disabled,
  className = "",
  ...liProps
}) {
  const label = <span
    className={classNames("filter-option-label", { "segment-disabled-label": disabled && tooltip })}
  >
    {optionLabel}
    {disabled && tooltip && (
      <span
        className="segment-disabled-icon"
        aria-label={`More information about ${optionLabel}`}
        role="tooltip"
      >
        <Tooltip title={tooltip}>
          <Info fontSize="small" />
        </Tooltip>
      </span>
      )}
  </span>

  return (
    <li
      {...liProps}
      aria-disabled={disabled || undefined}
      className={classNames(className, { "Mui-disabled": disabled })}
    >
      {label}
    </li>
  )
}

FilterOption.propTypes = {
  option: PropTypes.shape({
    label: PropTypes.string.isRequired,
    tooltip: PropTypes.string,
    value: PropTypes.string.isRequired,
  }).isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}
